import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

const SOURCE_COLOR = { ezlynx: "bg-[#101C47]", openphone: "bg-[#F92626]", gmail: "bg-emerald-600", chat: "bg-indigo-500" };

export function HourStrip({ hours = [], window, compact = false }) {
  const max = Math.max(1, ...hours.map((h) => h.total));
  const ws = window ? Number(window.start.split(":")[0]) : 8;
  const we = window ? Number(window.end.split(":")[0]) : 18;
  return (
    <TooltipProvider delayDuration={50}>
      <div className="flex items-end gap-[3px]" data-testid="hour-strip">
        {hours.map((h) => {
          const inWindow = h.hour >= ws && h.hour < we;
          const intensity = h.total === 0 ? 0 : Math.max(0.25, h.total / max);
          const dominant = Object.entries(h.by_source).sort((a, b) => b[1] - a[1])[0]?.[0];
          return (
            <Tooltip key={h.hour}>
              <TooltipTrigger asChild>
                <div className="flex flex-col items-center gap-1" data-testid={`hour-cell-${h.hour}`}>
                  <div className={cn("w-4 sm:w-5 rounded-sm transition-transform hover:scale-110", compact ? "h-6" : "h-10", h.total === 0 ? (inWindow ? "bg-slate-200" : "bg-slate-100") : SOURCE_COLOR[dominant] || "bg-slate-500")} style={{ opacity: h.total === 0 ? 1 : 0.35 + intensity * 0.65 }} />
                  {!compact && <span className={cn("text-[9px] font-mono", inWindow ? "text-slate-600" : "text-slate-400")}>{h.hour % 3 === 0 ? String(h.hour).padStart(2, "0") : ""}</span>}
                </div>
              </TooltipTrigger>
              <TooltipContent className="text-xs">{String(h.hour).padStart(2, "0")}:00–{String(h.hour + 1).padStart(2, "0")}:00 ET · {h.total} event(s){Object.entries(h.by_source).map(([s, n]) => ` · ${s} ${n}`)}</TooltipContent>
            </Tooltip>
          );
        })}
      </div>
    </TooltipProvider>
  );
}
